import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '@shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {PortalSetupComponent} from '@components/administration/portal-setup/portal-setup.component';
import {PortalSetupRoutingModule} from '@components/administration/portal-setup/portal-setup-routing.module';
import {PortalSetupMachineCategoriesComponent} from '@components/administration/portal-setup/portal-setup-machine-categories/portal-setup-machine-categories.component';
import {MachineCategoryEditComponent} from '@components/administration/portal-setup/portal-setup-machine-categories/modal/machine-category-edit/machine-category-edit.component';
import {MachineCategoryActionsComponent} from '@components/administration/portal-setup/portal-setup-machine-categories/machine-category-actions/machine-category-actions.component';
import {MachineCategoryEditColumnComponent} from '@components/administration/portal-setup/portal-setup-machine-categories/modal/machine-category-edit/machine-category-edit-column/machine-category-edit-column.component';
import {DragulaModule} from 'ng2-dragula';
import {EditColumnInputComponent} from '@components/administration/portal-setup/portal-setup-machine-categories/modal/machine-category-edit/machine-category-edit-column/edit-column-input/edit-column-input.component';

@NgModule({
  declarations: [
    PortalSetupComponent,
    PortalSetupMachineCategoriesComponent,
    MachineCategoryEditComponent,
    MachineCategoryActionsComponent,
    MachineCategoryEditColumnComponent,
    EditColumnInputComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbModule,
    SharedModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormsModule,
    PortalSetupRoutingModule,
    DragulaModule
  ],
  exports: [
    PortalSetupComponent
  ]
})

export class PortalSetupModule {

}
